module.exports = __webpack_public_path__ + "img/section6.dd653f97.png";